import Invoices from 'screens/Invoices';
import Invoice from 'screens/Invoices/Invoice';
import { paths } from 'routes/paths';
import { ROLES } from 'utilities/access';
import InvoiceViewGuard from './InvoiceViewGuard';
import InvoiceCreateGuard from './InvoiceCreateGuard';
import InvoiceEditGuard from './InvoiceEditGuard';
import InvoiceDuplicateGuard from './InvoiceDuplicateGuard';

const navRoutes = [
  {
    id: 'invoices',
    key: 'invoices',
    path: paths.invoices,
    exact: true,
    secure: true,
    disabled: false,
    component: Invoices
  }
];

const allRoutes = [
  ...navRoutes,
  {
    id: 'invoiceCreate',
    key: 'invoiceCreate',
    path: `${paths.invoices}/create`,
    exact: true,
    secure: true,
    disabled: false,
    component: InvoiceCreateGuard,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'invoiceEdit',
    key: 'invoiceEdit',
    path: `${paths.invoices}/:id/edit`,
    exact: true,
    secure: true,
    disabled: false,
    component: InvoiceEditGuard,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'invoice',
    key: 'invoice',
    path: `${paths.invoices}/:id`,
    exact: true,
    secure: true,
    disabled: false,
    component: Invoice,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'invoiceDuplicate',
    key: 'invoiceDuplicate',
    path: `${paths.invoices}/:id/duplicate`,
    exact: true,
    secure: true,
    disabled: false,
    component: InvoiceDuplicateGuard,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'invoiceView',
    key: 'invoiceView',
    path: `${paths.invoices}/:id/:view`,
    exact: true,
    secure: true,
    component: InvoiceViewGuard
  }
];

export default { navRoutes, allRoutes };
